import { render, staticRenderFns } from "./BalochistanMap.vue?vue&type=template&id=36c9e4db&scoped=true&"
import script from "./BalochistanMap.vue?vue&type=script&lang=js&"
export * from "./BalochistanMap.vue?vue&type=script&lang=js&"
import style0 from "./BalochistanMap.vue?vue&type=style&index=0&id=36c9e4db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c9e4db",
  null
  
)

export default component.exports